var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center justify-center"},[_c('svg',{staticClass:"icon",style:({
      width: _vm.width || _vm.iconSize,
      height: _vm.height || _vm.iconSize,
      // ios 上面，color 只有此处才生效。安卓是下面的 use 上加，就可以生效。
      color: _vm.color
    }),attrs:{"aria-hidden":"true"}},[_c('use',{style:({ color: _vm.color }),attrs:{"xlink:href":`#${_vm.icon}`}})]),_c('div',{style:({ color: _vm.color, fontSize: _vm.size, flexBasis: _vm.flexBasis, textAlign: _vm.textAlign })},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }